// A stream belongs to one selection generation, not merely a model ID: switching
// away and back must not revive a response from the abandoned connection.
export function createModelConversations(initialModel) {
  const conversations = new Map();
  let model = initialModel;
  let generation = 0;
  const read = () => conversations.get(model) || [];
  const write = (messages) => { conversations.set(model, messages); return messages; };
  const invalidate = () => {
    generation += 1;
    write(read().map((message) => message.streaming ? { ...message, streaming: false } : message));
  };
  return {
    read,
    remove(targetModel) {
      if (targetModel === model) invalidate();
      conversations.delete(targetModel);
    },
    select(nextModel) {
      invalidate();
      model = nextModel;
      return read();
    },
    replace(messages) {
      invalidate();
      return write(messages);
    },
    beginReply(message) {
      invalidate();
      const user = read().at(-1);
      const userId = user?.role === "user" ? user.id : null;
      write([...read().map((item) => item.id === userId ? { ...item, policyEligible: false } : item),
        { ...message, policyEligible: false }]);
      return { model, generation, id: message.id, userId };
    },
    isCurrent(token) {
      return token.model === model && token.generation === generation;
    },
    updateReply(token, text, done, result = { status: "completed" }) {
      if (!this.isCurrent(token)) return null;
      const policyEligible = done && result.status === "completed";
      return write(read().map((message) => {
        if (message.id === token.id) return { ...message, text, streaming: !done,
          policyEligible, ...(done ? { error: result.error || null, stopped: result.status === 'cancelled' } : {}) };
        if (message.id === token.userId) return { ...message, policyEligible };
        return message;
      }));
    },
  };
}

export function modelSessionKey(model, metadata = {}) {
  return JSON.stringify([model, metadata.releaseId || "", metadata.harnessProfile || ""]);
}
